import { render, staticRenderFns } from "./DragVerifyImgChip.vue?vue&type=template&id=440e7dc5&scoped=true"
import script from "./DragVerifyImgChip.vue?vue&type=script&lang=js"
export * from "./DragVerifyImgChip.vue?vue&type=script&lang=js"
import style0 from "./DragVerifyImgChip.vue?vue&type=style&index=0&id=440e7dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440e7dc5",
  null
  
)

export default component.exports